import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteRegionImageAPI,
  fetchRegionImagesAPI,
  uploadRegionImagesAPI,
} from "./regionImagesAPI";
import { showModal } from "../../statusModal/statusModal";

const initialState = {
  list: [],
  fetchStatus: "idle",
  uploadStatus: "idle",
  deleteStatus: "idle",
  error: null,
};

export const fetchRegionImages = createAsyncThunk(
  "regionImages/fetchImages",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchRegionImagesAPI();
      
      return data ;
     
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch images"
      );
    }
  }
);

export const deleteRegionImage = createAsyncThunk(
  "regionImages/deleteRegionImage",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const data = await deleteRegionImageAPI(id);
      dispatch(
        showModal({
          message: `تم حذف الصوره بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء حذف الصوره", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete image"
      );
    }
  }
);

export const uploadRegionImage = createAsyncThunk(
  "regionImages/uploadRegionImage",
  async (imageData, { dispatch, rejectWithValue }) => {
    try {
      const data = await uploadRegionImagesAPI(imageData);
      dispatch(
        showModal({
          message: `تم رفع الصوره بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء رفع الصوره", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admins"
      );
    }
  }
);

const regionImagesSlice = createSlice({
  name: "regionImages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegionImages.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchRegionImages.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = action.payload.data;
      })
      .addCase(fetchRegionImages.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(uploadRegionImage.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(uploadRegionImage.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(uploadRegionImage.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(deleteRegionImage.pending, (state) => {
        state.uploadStatus = "loading";
        state.error = null;
      })
      .addCase(deleteRegionImage.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.list = state.list.filter(({ _id }) => _id !== action.payload);
      })
      .addCase(deleteRegionImage.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.error = action.payload.error;
      });
  },
});

export default regionImagesSlice.reducer;
